import History from '../../../core/history/history';
import EditorFacade from '../../../facade/editor/editor';
import { instance as CompanyFactory } from '../../../factory/company';
import FormatFactory from '../../../factory/formats';
import UserInfoFactory from '../../../factory/user-info';
import WorkflowFactory from '../../../factory/workflow';
import createLayoutButton from '../contents/layout-button/layout-button';
import { initTopBar } from '../init-top-bar';

import buttonTemplate from './button.hbs';

module.exports = {
  downloadrequestEvent: function (event) {
    this.displayRequestModal(event, 'download');
  },

  sharerequestEvent: function (event) {
    this.displayRequestModal(event, 'share');
  },

  printrequestEvent: function (event) {
    this.displayRequestModal(event, 'print');
  },

  displayRequestModal: function (event, type) {
    const isWip = !!$(event.currentTarget).find('.wip').length;
    const trans = INKIVE.TranslateHelper.translate;
    const PromptModal = require('../../../modal/prompt');
    const message = (isWip ? trans('advice.content.workflow_request_wip') + ' ' : '') +
      trans('modal.prompt.request_explain');

    const prompt = new PromptModal({
      long: true,
      label: message
    });
    prompt.getFormHtml().find('textarea').hide();
    const modal = INKIVE.Modal.modalWindow(prompt.getFormHtml(), {
      width: 500,
      headerIcon: 'desygner-icon-add-job',
      headerTitle: trans('modal.prompt.request', { action: type }),
      buttons: [{
        title: trans(isWip ? 'modal.buttons.get_back' : 'modal.buttons.send_request'),
        onClick: () => {
          modal.close();
          isWip || this.createRequest(type);
        }
      }]
    });
  },

  resetFormat: function () {
    this.sizeView.format = FormatFactory.getCurrentSize();
  },

  createRequest: function (action) {
    const $button = this.$el.children('.options')
      .children('button[data-action="' + action + 'request"]');

    const output = {
      output_id: this.design.id,
      output_type: 'brand_design',
      output_action: action
    };

    INKIVE.Modal.togglePageLoader(true);

    $.when(
      CompanyFactory.get(['memberships', 'me']),
      CompanyFactory.get(['designs', INKIVE.C.BOOK.encodedId]),
      EditorFacade.handle('page', 'save')
    ).then((memberhsip, design) => {
      output.output_id = design.id;

      const job = {
        assigned_to_id: memberhsip.id,
        outputs: [output]
      };

      WorkflowFactory.post('jobs/simple', job).then((response) => {
        this.requestsApplied.push(action);
        this.jobs.push({ id: response.id, state: 'open' });
        INKIVE.C.IS_UNDER_REVIEW || this.blockDesign(this);
        $button.addClass('request-pending').prepend('<i class="fa fa-clock-o wip"></i>');
        INKIVE.Modal.togglePageLoader(false);
      });
    });
  },

  initialize: function () {
    // Code for top-submenu (aka top-bar) will be progressively moved to src/views/top-bar
    initTopBar();

    createLayoutButton();

    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.requestsApplied = [];

    _.bindAll(this, 'displayNoActionsLeftError');

    this.initSubView();
    this.initProjectName();
    this.initTableOfContentsModal();

    History.on('reload', _.bind(this.refreshHistoryUI, this));
    History.on('change', _.bind(this.refreshHistoryUI, this));
    History.on('undo', _.bind(this.refreshHistoryUI, this));
    History.on('redo', _.bind(this.refreshHistoryUI, this));

    const restrictionsFacade = require('../../../facade/restrictions/restrictions');
    const $options = this.$el.children('.options');

    this.can = _.bind(restrictionsFacade.isFunctionalityAllowed, restrictionsFacade);
    this.blockActions($options);
    EditorFacade.on('page.move_to', () => this.resetFormat());

    restrictionsFacade.initialize()
      .then(_.bind(this.unblockAllowedActions, this, $options, true))
      .then(_.bind(this.addRequestActions, this, $options));

    UserInfoFactory.get().then(() => this._initUpgradeButton());
  },

  blockActions: function ($options) {
    ['share', 'download', 'animation'].forEach((action) => {
      $options.children(`button[data-action="${action}"]`).addClass('hidden');
    });
  },

  // Professional print action handled on first load (components-loader)
  unblockAllowedActions: function ($options, toggle) {
    $options.children('button[data-action="share"]')
      .toggleClass('hidden', !this.can('function_share_file')).toggleClass('disabled', toggle);

    $options.children('button[data-action="download"]')
      .toggleClass('hidden', !this.can('function_download_file')).toggleClass('disabled', toggle);

    $options.children('button[data-action="animation"]')
      .toggleClass('hidden', !this.can('function_animation_file'));
  },

  addRequestActions: function ($options) {
    const _resetButtons = () => resetButtons.call(this);

    CompanyFactory.get(['designs', INKIVE.C.BOOK.encodedId]).then((design) => {
      this.design = design;

      WorkflowFactory.isEnabled().then(() => {
        WorkflowFactory.getJobs(design, 'brand_design').then((jobs) => {
          this.jobs = Array.isArray(jobs) ? jobs : [];
          addButtons.call(this);
          addWipHint.call(this);
          if (this.design.is_under_review || this.requestsApplied.length) {
            this.blockDesign(this);
          } else if (designHasRequest.call(this)) {
            History.on('change', _resetButtons);
          }
        });
      }, () => {
        this.unblockAllowedActions($options, false);
      });
    });

    function resetButtons () {
      ['print', 'share', 'download'].forEach((action) => {
        const requestButton = document.querySelector(`[data-action="${action}request"]`);
        if (action === 'print') {
          action = 'order-print';
        }

        if (requestButton) {
          requestButton.classList.remove('hidden');
          document.querySelector(`[data-action="${action}"]`).classList.add('hidden');
        }
      });

      History.off('change', _resetButtons);
    }

    function designHasRequest () {
      return this.can('function_request_print_file') ||
        this.can('function_request_share_file') ||
        this.can('function_request_download_file');
    }

    function canAskForApproval (action, $button) {
      return $button.length &&
        this.can('function_request_' + action + '_file');
    }

    function addButtons () {
      const $printButton = $options.children('button[data-action="order-print"]').removeClass('disabled');
      const $shareButton = $options.children('button[data-action="share"]').removeClass('disabled');
      const $downloadButton = $options.children('button[data-action="download"]').removeClass('disabled');

      canAskForApproval.call(this, 'print', $printButton) && $printButton.after(
        $printButton.clone().attr('data-action', 'printrequest').removeClass('hidden')) &&
      $printButton.addClass('hidden');

      canAskForApproval.call(this, 'share', $shareButton) && $shareButton.after(buttonTemplate({
        text: $options.children('button[data-action="share"]').text(),
        icon: '#share---triangle',
        action: 'sharerequest',
        expandable: 'expandable',
        newDesign: true
      })) && $shareButton.addClass('hidden');

      canAskForApproval.call(this, 'download', $downloadButton) && $downloadButton.after(buttonTemplate({
        text: $options.children('button[data-action="download"]').text(),
        icon: '#download',
        action: 'downloadrequest',
        expandable: 'expandable',
        newDesign: true
      })) && $downloadButton.addClass('hidden');

      this.delegateEvents();
    }

    function addWipHint () {
      const actionAllowed = (job) => {
        let actionAllowed = true;

        if (['finished'].includes(job.state)) {
          const updatedDate = new Date(job.updated_at);
          actionAllowed = !this.design.pages.some(page => new Date(page.last_mod * 1000) > updatedDate);
        }

        return actionAllowed;
      };

      const nonClosedJobs = this.jobs.filter((job) => {
        const output = job.outputs[0] || {};

        return job.state !== 'closed' && ['print', 'share', 'download'].includes(output.output_action);
      });

      nonClosedJobs.forEach((job) => {
        const output = job.outputs[0];
        const type = output.output_action;
        const $button = $options.children('button[data-action="' + type + 'request"]');

        if (output.is_ready) {
          if (actionAllowed(job) && !this.requestsApplied.includes(type)) {
            $button.addClass('hidden');
            $button.siblings('button[data-action="' + (type === 'print' ? 'order-print' : type) + '"]')
              .removeClass('hidden');
          }
        } else if (!$button.find('.wip').length) {
          $button.addClass('request-pending').prepend('<i class="fa fa-clock-o wip"></i>');
          this.requestsApplied.includes(type) || this.requestsApplied.push(type);
        }
      });
    }
  },

  blockDesign: async (_this) => {
    const member = await UserInfoFactory.getMembership();
    const isAdmin = member?.permissions?.campaigns_manage;
    if (isAdmin) {
      return;
    }
    let rollback = true;
    const requests = _this.requestsApplied;
    const redoButton = document.querySelector('.menus button[data-action="redo"]');
    const clearJobStatus = () => {
      _this.jobs.forEach((job) => {
        job.state === 'open' && WorkflowFactory.patch('jobs', job, 'closed');
      });
      document.querySelectorAll('.fa-clock-o.wip').forEach((e) => e.remove());
      INKIVE.C.IS_UNDER_REVIEW = false;
    };

    const changeListener = () => {
      const message = `${INKIVE.TranslateHelper.translate('modal.prompt.changes_will_cancel_request')}
        <ul>
          ${requests.map((type) => `<li>${INKIVE.TranslateHelper.translate('modal.prompt.' + type)}</li>`).join('')}
        </ul>
      `;

      const modal = INKIVE.Modal.modalWindow(message, {
        classes: 'request-modal',
        width: 600,
        headerIcon: 'desygner-icon-add-job',
        closeCallback: () => {
          if (rollback) {
            EditorFacade.handle('history', 'undo');
            redoButton.classList.add('disabled');
          }
        },
        buttons: [
          {
            title: INKIVE.TranslateHelper.translate('modal.buttons.get_back'),
            cls: 'no-background',
            onClick: () => {
              modal.close();
            }
          },
          {
            title: INKIVE.TranslateHelper.translate('modal.buttons.edit_design_anyway'),
            onClick: () => {
              History.off('change', changeListener);
              clearJobStatus();
              rollback = false;
              modal.close();
            }
          }]
      });
    };

    History.on('change', changeListener);
    INKIVE.C.IS_UNDER_REVIEW = true;
  }
};
